import { DashboardGridScreen } from 'screens/dashboard';

export default DashboardGridScreen;
